import { ERROR_QUOTE, GET_QUOTES, GET_ALL_QUOTES, GET_QUOTE } from '../actions/types';

const initialState = {
  quote: {},
  quotes: [],
  quotesAll: [],
  loading: true,
  error: {}
}

export default function(state = initialState, action){
  const { type, payload } = action;

  switch(type){
    case GET_QUOTE:
      return {
        ...state,
        quote: payload,
        loading: false,
        error: {}
      }
    case GET_QUOTES:
      return {
        ...state,
        quotes: payload,
        loading: false,
        error: {}
      }
    case GET_ALL_QUOTES:
      return {
        ...state,
        quotesAll: payload,
        loading: false,
        error: {}
      }
    case ERROR_QUOTE:
      return {
        ...state,
        error: payload,
        loading: false
      }
    default:
      return state;
  }
}